import { create } from 'zustand';

interface SidebarStore {
  collapsed: boolean;
  toggle: () => void;
  mobileOpen: boolean;
  setMobileOpen: (open: boolean) => void;
  toggleMobile: () => void;
  expandedSections: Record<string, boolean>;
  toggleSection: (section: string) => void;
}

export const useSidebarStore = create<SidebarStore>((set) => ({
  collapsed: false,
  toggle: () => set((s) => ({ collapsed: !s.collapsed })),
  mobileOpen: false,
  setMobileOpen: (open) => set({ mobileOpen: open }),
  toggleMobile: () => set((s) => ({ mobileOpen: !s.mobileOpen })),
  expandedSections: { products: true, purchasing: true },
  toggleSection: (section) =>
    set((s) => ({
      expandedSections: {
        ...s.expandedSections,
        [section]: !s.expandedSections[section],
      },
    })),
}));
